import { render, staticRenderFns } from "./AdmisionImpresion.vue?vue&type=template&id=972bb3b0&scoped=true"
import script from "./AdmisionImpresion.vue?vue&type=script&lang=js"
export * from "./AdmisionImpresion.vue?vue&type=script&lang=js"
import style0 from "./AdmisionImpresion.vue?vue&type=style&index=0&id=972bb3b0&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972bb3b0",
  null
  
)

export default component.exports